














































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { settings, auth, VIPCapability, IpRuleType } from '@/loader';
import dayjs, { Dayjs } from 'dayjs';

@Component
export default class IpRule extends Vue {
	@Prop({ type: String, required: true })
	public type!: IpRuleType;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: VIPCapability, default: null })
	public check!: VIPCapability | null;

	public get compareDate(): Dayjs {
		return !this.check || this.check.isDraft || !this.check.date ? dayjs() : this.check.date;
	}

	public get canEdit(): boolean {
		return !this.readonly && auth.user?.capabilities.manage_valentin_ip || false;
	}

	public get title(): string {
		switch (this.type) {
			case "exceptional":
				return "exceptionnelle";
			case "probationary":
				return "probatoire";
			case "customary":
			default:
				return "coutumière";
		}
	}

	public get qty1() {
		return settings[`${this.type}1_qty`];
	}
	public set qty1(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}1_qty": ${value} }`));
	}

	public get limit1() {
		return settings[`${this.type}1_limit`];
	}
	public set limit1(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}1_limit": ${value} }`));
	}

	public get qty2() {
		return settings[`${this.type}2_qty`];
	}
	public set qty2(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}2_qty": ${value} }`));
	}

	public get limit2() {
		return settings[`${this.type}2_limit`];
	}
	public set limit2(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}2_limit": ${value} }`));
	}

	public get duration() {
		return settings[`${this.type}_duration`];
	}
	public set duration(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}_duration": ${value} }`));
	}

	public get extensionDuration() {
		return settings[`${this.type}_extension_duration`];
	}
	public set extensionDuration(value: number) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}_extension_duration": ${value} }`));
	}

	public get hasExtension() {
		return settings[`${this.type}_has_extension`];
	}
	public set hasExtension(value: boolean) {
		if (this.readonly) {
			return;
		}
		settings.set(JSON.parse(`{ "${this.type}_has_extension": ${value} }`));
	}

	public get certificates1() {
		return this.check?.certificates.filter((cc) => {
			var diff = cc.certificate?.date?.diff(this.compareDate, "years");
			diff = Math.abs(diff === undefined ? 99 : diff);
			return this.limit1 === 0 || diff < this.limit1;
		}).slice(0, this.qty1) || [];
	}

	public get certificates2() {
		var cert1 = this.certificates1;
		return this.check?.certificates.filter((cc) => {
			var diff = cc.certificate?.date?.diff(this.compareDate, "years");
			diff = Math.abs(diff === undefined ? 99 : diff);
			return (this.limit2 === 0 || diff < this.limit2) && !cert1.includes(cc);
		}).slice(0, this.qty2) || [];
	}

	public get valid1(): boolean {
		if (!this.check) {
			return false;
		}
		return this.certificates1.length === this.qty1;
	}

	public get valid2(): boolean {
		if (!this.check) {
			return false;
		}
		return this.certificates2.length === this.qty2;
	}
}
